import React from 'react';

import constants from 'constants/constants';
import { Controller } from 'react-hook-form';

import { useCreateFromScratchReportModalLogic } from 'components/Dashboards/Reporting/CreateFromScratchReportModal/CreateFromScratchReportModal.logic';
import { useCreateFromScratchReportModalProvider } from 'components/Dashboards/Reporting/CreateFromScratchReportModal/CreateFromScratchReportModal.provider';
import { REPORT_NAME_MAX_LENGTH } from 'components/Dashboards/Reporting/reporting.consts';
import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { TextInput } from 'components/DesignSystem/TextInput/TextInput';
import { CustomizedFormErrorMessage } from 'components/common';

import classes from './CreateFromScratchReportModal.module.scss';

interface Props {
    isModalOpen: boolean;
    setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const FORM_ID = 'create-from-scratch-report-form';

export const CreateFromScratchReportModal = ({ isModalOpen, setIsModalOpen }: Props) => {
    const { api } = useCreateFromScratchReportModalProvider();
    const { logic } = useCreateFromScratchReportModalLogic({ api, setIsModalOpen });

    return (
        <Modal
            open={isModalOpen}
            onClose={logic.hideModal}
            title={'Create Report'}
            width={constants.DEFAULT_MODAL_WIDTH}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={logic.hideModal}>
                        Cancel
                    </Button>
                    <Button
                        size={'large'}
                        isLoading={api.setReport.instance.isLoading}
                        variant={'primary'}
                        type={'submit'}
                        form={FORM_ID}
                    >
                        Create
                    </Button>
                </>
            }
        >
            <form id={FORM_ID} onSubmit={logic.form.handleSubmit(logic.onCreateReport)}>
                <div className={classes.createFromScratchReportModalContainer}>
                    <label htmlFor={'reportName'}>Name:</label>
                    <Controller
                        render={({ field }) => (
                            <TextInput
                                {...field}
                                onClear={() => logic.form.setValue('reportName', '')}
                                id={'report-name-input'}
                                placeholder={'Enter report name...'}
                            />
                        )}
                        name={'reportName'}
                        control={logic.form.control}
                        rules={{
                            required: 'Report name is required',
                            minLength: { value: 2, message: 'Report name must be longer than 2 characters' },
                            maxLength: {
                                value: REPORT_NAME_MAX_LENGTH,
                                message: `Report name can't be longer than ${REPORT_NAME_MAX_LENGTH} characters`,
                            },
                        }}
                    />
                    {logic.form.formState.errors.reportName && (
                        <CustomizedFormErrorMessage text={logic.form.formState.errors.reportName.message} />
                    )}
                </div>
            </form>
        </Modal>
    );
};
